// extracted by mini-css-extract-plugin
export default {"map":"Marker_map__p9RpY"};